export const PREVIOUS_YEAR_EFIRMA_TYPEFORM = 'https://form.typeform.com/to/OAnHtHE6#';
